import { createFileRoute } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { vmcTechnicalQuery } from '@/queries/vmc-technical.query'

export const Route = createFileRoute('/_dashboard/site/$id/vmc/technical/')({
  loader({ context, params }) {
    return context.queryClient.ensureQueryData(vmcTechnicalQuery(Number(params.id)))
  },
  pendingComponent: PendingComponent,
})
